import './style.scss';

import { Tooltip } from 'antd';

import { IconFullScreen } from 'assets/icons';

type ButtonFullscreenProps = {
  onClick?: () => void;
  disabled?: boolean;
};

export const ButtonFullscreen = ({ onClick, disabled = false }: ButtonFullscreenProps) => (
  <Tooltip title="Fullscreen">
    <button className="ui-button-fullscreen" onClick={onClick} disabled={disabled}>
      <IconFullScreen />
    </button>
  </Tooltip>
);
